function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getMainRangeChannel, getSecondaryRangeChannel, getSizeChannel, getVgPositionChannel } from '../../../channel';
import { isFieldOrDatumDef } from '../../../channeldef';
import * as log from '../../../log';
import { isRelativeBandSize } from '../../../mark';
import { getMarkStyleConfig } from '../../common';
import { positionOffset } from './offset';
import { vgAlignedPositionChannel } from './position-align';
import { pointPosition, pointPositionDefaultRef } from './position-point';
import * as ref from './valueref';
/**
 * Utility for area/rule position, which can be either point or range.
 * (One of the axes should be point and the other should be range.)
 */
export function pointOrRangePosition(channel, model, _ref) {
  var defaultPos = _ref.defaultPos,
    defaultPos2 = _ref.defaultPos2,
    range = _ref.range;
  if (range) {
    return rangePosition(channel, model, {
      defaultPos: defaultPos,
      defaultPos2: defaultPos2
    });
  }
  return pointPosition(channel, model, {
    defaultPos: defaultPos
  });
}
export function rangePosition(channel, model, _ref2) {
  var defaultPos = _ref2.defaultPos,
    defaultPos2 = _ref2.defaultPos2;
  var markDef = model.markDef,
    config = model.config;
  var channel2 = getSecondaryRangeChannel(channel);
  var sizeChannel = getSizeChannel(channel);
  var pos2Mixins = pointPosition2OrSize(model, defaultPos2, channel2);
  var vgChannel = pos2Mixins[sizeChannel] ?
  // If there is width/height, we need to position the marks based on the alignment.
  vgAlignedPositionChannel(channel, markDef, config) :
  // Otherwise, make sure to apply to the right Vg Channel (for arc mark)
  getVgPositionChannel(channel);
  return _objectSpread(_objectSpread({}, pointPosition(channel, model, {
    defaultPos: defaultPos,
    vgChannel: vgChannel
  })), pos2Mixins);
}
/**
 * Return encode for x2, y2.
 * If channel is not specified, return one channel based on orientation.
 */
function pointPosition2OrSize(model, defaultPos, channel) {
  var encoding = model.encoding,
    mark = model.mark,
    markDef = model.markDef,
    stack = model.stack,
    config = model.config;
  var baseChannel = getMainRangeChannel(channel);
  var sizeChannel = getSizeChannel(channel);
  var vgChannel = getVgPositionChannel(channel);
  var channelDef = encoding[baseChannel];
  var scaleName = model.scaleName(baseChannel);
  var scale = model.getScaleComponent(baseChannel);
  var _ref3 = channel in encoding || channel in markDef ? positionOffset({
      channel: channel,
      markDef: markDef,
      encoding: encoding,
      model: model
    }) : positionOffset({
      channel: baseChannel,
      markDef: markDef,
      encoding: encoding,
      model: model
    }),
    offset = _ref3.offset;
  if (!channelDef && (channel === 'x2' || channel === 'y2') && (encoding.latitude || encoding.longitude)) {
    var vgSizeChannel = getSizeChannel(channel);
    var size = model.markDef[vgSizeChannel];
    if (size != null) {
      return _defineProperty({}, vgSizeChannel, {
        value: size
      });
    } else {
      return _defineProperty({}, vgChannel, {
        field: model.getName(channel)
      });
    }
  }
  var valueRef = position2Ref({
    channel: channel,
    channelDef: channelDef,
    channel2Def: encoding[channel],
    markDef: markDef,
    config: config,
    scaleName: scaleName,
    scale: scale,
    stack: stack,
    offset: offset,
    defaultRef: undefined
  });
  if (valueRef !== undefined) {
    return _defineProperty({}, vgChannel, valueRef);
  }
  // TODO: check width/height encoding here once we add them
  // no x2/y2 encoding, then try to read x2/y2 or width/height based on precedence:
  // markDef > config.style > mark-specific config (config[mark]) > general mark config (config.mark)
  return position2orSize(channel, markDef) || position2orSize(channel, _defineProperty(_defineProperty({}, channel, getMarkStyleConfig(channel, markDef, config.style)), sizeChannel, getMarkStyleConfig(sizeChannel, markDef, config.style))) || position2orSize(channel, config[mark]) || position2orSize(channel, config.mark) || _defineProperty({}, vgChannel, pointPositionDefaultRef({
    model: model,
    defaultPos: defaultPos,
    channel: channel,
    scaleName: scaleName,
    scale: scale
  })());
}
export function position2Ref(_ref8) {
  var channel = _ref8.channel,
    channelDef = _ref8.channelDef,
    channel2Def = _ref8.channel2Def,
    markDef = _ref8.markDef,
    config = _ref8.config,
    scaleName = _ref8.scaleName,
    scale = _ref8.scale,
    stack = _ref8.stack,
    offset = _ref8.offset,
    defaultRef = _ref8.defaultRef;
  if (isFieldOrDatumDef(channelDef) && stack &&
  // If fieldChannel is X and channel is X2 (or Y and Y2)
  channel.charAt(0) === stack.fieldChannel.charAt(0)) {
    return ref.valueRefForFieldOrDatumDef(channelDef, scaleName, {
      suffix: 'start'
    }, {
      offset: offset
    });
  }
  return ref.midPointRefWithPositionInvalidTest({
    channel: channel,
    channelDef: channel2Def,
    scaleName: scaleName,
    scale: scale,
    stack: stack,
    markDef: markDef,
    config: config,
    offset: offset,
    defaultRef: defaultRef
  });
}
function position2orSize(channel, markDef) {
  var sizeChannel = getSizeChannel(channel);
  var vgChannel = getVgPositionChannel(channel);
  if (markDef[vgChannel] !== undefined) {
    return _defineProperty({}, vgChannel, ref.widthHeightValueOrSignalRef(channel, markDef[vgChannel]));
  } else if (markDef[channel] !== undefined) {
    return _defineProperty({}, vgChannel, ref.widthHeightValueOrSignalRef(channel, markDef[channel]));
  } else if (markDef[sizeChannel]) {
    var dimensionSize = markDef[sizeChannel];
    if (isRelativeBandSize(dimensionSize)) {
      log.warn(log.message.relativeBandSizeNotSupported(sizeChannel));
    } else {
      return _defineProperty({}, sizeChannel, ref.widthHeightValueOrSignalRef(channel, dimensionSize));
    }
  }
  return undefined;
}